import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiSave, FiEdit } from "react-icons/fi";

const AdminMembership = () => {
  const [membership, setMembership] = useState({
    heading: "",
    subHeading: "",
  });
  const [initialMembership, setInitialMembership] = useState({
    heading: "",
    subHeading: "",
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState(null);

  // Fetch membership content on mount
  useEffect(() => {
    const fetchMembership = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/membership/get-membership-data`
        );
        if (data?.membership) {
          setMembership(data.membership);
          setInitialMembership(data.membership);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMembership();
  }, []);

  // Handle save
  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/membership/create-membership-data`,
        {
          heading: membership.heading,
          subHeading: membership.subHeading,
        }
      );
      setMessage(data.message || "Membership data saved successfully!");
      setTimeout(() => setMessage(null), 5000);
      setInitialMembership(membership);
      setEditing(false);
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong.");
    } finally {
      setSaving(false);
    }
  };

  // Detect unsaved changes
  const hasChanges =
    membership.heading !== initialMembership.heading ||
    membership.subHeading !== initialMembership.subHeading;

  return (
    <div className="min-h-screen bg-transparent p-6 w-full">
      <h1 className="text-3xl font-heading font-bold mb-8 bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent inline-block">
        Manage Membership Content
      </h1>

      {loading ? (
        <div className="bg-white shadow-xl rounded-2xl p-6 space-y-6 animate-pulse">
          <div className="h-4 w-32 bg-gray-300 rounded mb-2"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
      ) : (
        <form
          onSubmit={handleSave}
          className="bg-white rounded-2xl space-y-6 max-w-full"
        >
          {/* Heading */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Heading
            </label>
            <input
              type="text"
              value={membership.heading}
              onChange={(e) =>
                setMembership({ ...membership, heading: e.target.value })
              }
              className="w-full px-4 py-2 border border-black rounded-lg outline-none focus:ring-1 focus:ring-black"
              placeholder="Enter membership heading"
              required
              disabled={!editing}
            />
          </div>

          {/* Subheading */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sub Heading
            </label>
            <textarea
              value={membership.subHeading}
              onChange={(e) =>
                setMembership({ ...membership, subHeading: e.target.value })
              }
              className="w-full px-4 py-2 border border-black rounded-lg outline-none focus:ring-1 focus:ring-black"
              placeholder="Enter membership subheading"
              rows={4}
              required
              disabled={!editing}
            />
          </div>

          {/* Buttons */}
          <div
            className={`w-full flex items-center ${
              message ? "justify-between" : "justify-end"
            } gap-4`}
          >
            {message && (
              <p className="text-sm text-green-600 font-medium">{message}</p>
            )}
            {!editing ? (
              <button
                type="button"
                onClick={() => setEditing(true)}
                className="w-52 px-6 py-2 rounded-xl shadow-md font-medium 
                 text-gray-800 bg-gradient-to-r from-gray-100 to-gray-300
                 hover:from-gray-200 hover:to-gray-400 
                 active:scale-95 transition-all duration-200 ease-in-out
                 flex items-center justify-center gap-2"
              >
                <FiEdit className="text-lg text-gray-600" />
                Edit Details
              </button>
            ) : (
              <button
                type="submit"
                disabled={saving || !hasChanges}
                className="flex items-center justify-center w-52 gap-2 bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white px-6 py-2 rounded-lg shadow-lg hover:opacity-90 transition disabled:opacity-50"
              >
                {saving ? (
                  <div className="spinner w-full"></div>
                ) : (
                  <>
                    <FiSave size={18} />
                    Save Changes
                  </>
                )}
              </button>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

export default AdminMembership;
